import React from "react";
import {
  NationalDataAuthType,
  NationalDataAuthTypeIcon,
  NationalDataAuthTypeKRStr,
} from "@utils/Constants";
import styled from "styled-components";
import { Colors } from "@utils";

interface AuthTypeButtonProps {
  authType: NationalDataAuthType;
  selected: boolean;
  onSelectType: (authType: NationalDataAuthType) => any;
}

const Container = styled.div<{
  selected: boolean;
}>`
  width: 148px;
  height: 61px;
  background: #fcfcfe;
  border-radius: 8px;
  border: 1px solid
    ${(props) => (props.selected ? Colors.primaryGreen : "#D9D9D9")};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  & * {
    cursor: pointer;
  }
`;

const Img = styled.img`
  width: 25px;
  height: 25px;
  margin-bottom: 2px;
`;

const AuthTypeButton: React.FC<AuthTypeButtonProps> = ({
  authType,
  selected,
  onSelectType,
}) => {
  return (
    <Container selected={selected} onClick={() => onSelectType(authType)}>
      <Img src={NationalDataAuthTypeIcon.Small[authType]} />
      <div
        className="text-[16px] font-[500]"
        style={{ color: Colors.totallyBlack }}
      >
        {NationalDataAuthTypeKRStr[authType]} 인증서
      </div>
    </Container>
  );
};

export default AuthTypeButton;
